export default {
  visual: {
    label: 'ORCA — dein persönliches Marktinformationssystem',
    logoAlt: 'ORCA',
    eyebrow: 'MARKTINTELLIGENZ',
    slogan: 'Weniger Rauschen. Mehr Klarheit.',
    domains: 'Krypto · Aktien · Makro · Orca AI',
    nodes: { coins: 'Coin-News', alerts: 'Preis-Alerts', whales: 'OrcaWatch', calendar: 'Kalender', ai: 'Orca AI', portfolio: 'Portfolio', social: 'X Radar', wallstreet: 'Wall Street' },
  },
  language: { label: 'Sprache', ru: 'RU', en: 'EN', de: 'DE' },
  preloader: 'Markt wird analysiert…',
  loading: 'Wird geladen',
  checking: { title: 'ORCA wird geöffnet', text: 'Deine sichere Sitzung wird geprüft…' },
  offline: { title: 'Keine Verbindung', text: 'Prüfe deine Internetverbindung und versuche es erneut.' },
  error: {
    title: 'ORCA ist vorübergehend nicht erreichbar',
    email: 'Gib eine gültige E-Mail-Adresse ein.',
    code: 'Gib den sechsstelligen Code ein.',
    codeExpired: 'Dieser Code ist abgelaufen. Fordere einen neuen an.',
    invalidCode: 'Der Code ist falsch oder abgelaufen.',
    provider: 'Diese Anmeldung konnte nicht bestätigt werden. Versuche es erneut.',
    expiredFlow: 'Diese Anmeldung ist abgelaufen. Beginne noch einmal.',
    expiredLink: 'Dieser Link ist ungültig oder abgelaufen.',
    rateLimited: 'Zu viele Versuche. Versuche es später erneut.',
    offline: 'Keine Verbindung. Prüfe deine Internetverbindung.',
    service: 'Der Dienst ist vorübergehend nicht erreichbar. Versuche es später erneut.',
    generic: 'Etwas ist schiefgelaufen. Versuche es erneut.',
  },
  action: {
    google: 'Mit Google fortfahren',
    email: 'Mit E-Mail fortfahren',
    telegram: 'Über Telegram verbinden',
    continue: 'Weiter',
    verify: 'Bestätigen',
    back: 'Zurück',
    cancel: 'Abbrechen',
    tryAgain: 'Erneut versuchen',
    checkAgain: 'Erneut prüfen',
    continueApp: 'Weiter zu ORCA',
    backToSignIn: 'Zurück zur Anmeldung',
  },
  welcome: {
    eyebrow: 'WEB ORCA',
    title: 'Willkommen',
    text: 'Melde dich an oder erstelle ein kostenloses Web-Konto.',
    or: 'oder',
    legal: 'Wenn du fortfährst, bestätigst du, dass ORCA ein Informations- und Analysedienst ist.',
  },
  session: { expired: 'Deine Sitzung ist beendet. Melde dich erneut an, um fortzufahren.' },
  telegram: {
    offerTitle: 'Hast du bereits ein ORCA-Abo in Telegram?',
    offerText: 'Verbinde dein bestehendes Plus, Premium oder aktives Trial mit Web ORCA.',
    notFoundTitle: 'Kein ORCA-Konto in Telegram gefunden',
    notFoundText: 'Wenn du neu bei ORCA bist, registriere dich mit E-Mail oder Google.',
    paidTitle: 'Kein aktives Abo gefunden',
    paidText: 'Die Telegram-Verbindung ist mit Plus, Premium oder einem aktiven Trial verfügbar. Registriere dich mit E-Mail oder Google, um Web ORCA zu nutzen.',
    openBot: 'ORCA in Telegram öffnen',
  },
  email: {
    eyebrow: 'E-MAIL',
    title: 'Mit E-Mail anmelden',
    text: 'Wir senden dir einen Einmalcode. Du brauchst kein Passwort.',
    requiredEyebrow: 'NOCH EIN SCHRITT',
    requiredTitle: 'E-Mail hinzufügen',
    requiredText: 'Du brauchst sie für die Anmeldung und die Sicherheit deines Kontos. Dieser Schritt kann nicht übersprungen werden.',
    googleVerification: 'Bestätige deine aktuelle E-Mail mit einem Einmalcode.',
    label: 'E-Mail',
    placeholder: 'name@example.com',
  },
  otp: {
    eyebrow: 'BESTÄTIGUNG',
    title: 'Code eingeben',
    text: 'Wir haben einen sechsstelligen Code an {{email}} gesendet.',
    label: 'Code aus der E-Mail',
    help: 'Der Code ist 10 Minuten gültig.',
    expired: 'Der Code ist abgelaufen. Fordere einen neuen an.',
    resend: 'Neuen Code senden',
    resendIn: 'Erneut senden in {{seconds}} s',
    changeEmail: 'E-Mail ändern',
  },
  link: {
    eyebrow: 'KONTEN VERBINDEN',
    title: 'Diese E-Mail wird bereits in Web ORCA verwendet',
    text: 'Du hast bereits ein separates Web-Konto. Du kannst es mit deinem ORCA-Abo in Telegram verbinden.',
    keepTitle: 'Nach dem Verbinden bleiben erhalten:',
    keepPlan: 'dein Plus, Premium oder Trial aus Telegram',
    keepSettings: 'Einstellungen und Daten des bezahlten Kontos',
    keepSchedule: 'sein Abo und Zeitplan',
    webFree: 'Das separate Web-Free-Konto wird damit verbunden.',
    confirm: 'Konten verbinden',
    checking: 'Bestätigung und Verfügbarkeit werden geprüft…',
    waitTitle: 'Verbindung in Telegram bestätigen',
    waitText: 'Öffne den Telegram-Link, bestätige dein Konto und kehre dann hierher zurück.',
    expiredTitle: 'Dieser Link ist nicht mehr gültig',
    expiredText: 'Fordere einen neuen Link an und beginne die Verbindung erneut.',
  },
  blocked: {
    title: 'Diese Konten können jetzt nicht verbunden werden',
    text: 'Der aktuelle Zugang beider Konten oder eine bestehende Verbindung verhindert eine sichere Zusammenführung. Es wurde nichts geändert.',
  },
  conflict: {
    title: 'Die Konten wurden nicht verbunden',
    text: 'Diese Anmeldemethode ist bereits mit einem anderen ORCA-Konto verbunden. Nutze E-Mail oder wende dich an den Support.',
  },
};
